import type { DateValue } from "react-aria-components";
import React from "react";

import { Checkbox2 } from "@/ui2/atoms/Checkbox";
import { cn } from "@/lib/helpers/cn";

import { DateRangeFilter } from "./components/DateRangeFilter";
import { NoteTypeFilter } from "./components/NoteTypeFilter";
import { SearchFilter } from "./components/SearchFilter";

type NoteFiltersProps = {
  dateEnd: DateValue;
  dateStart: DateValue;
  isAllSelected: boolean;
  isAuthorizedToExportNotes: boolean;
  onDateEndChange: (date: DateValue) => void;
  onDateStartChange: (date: DateValue) => void;
  onNoteTypeChange: (id: string) => void;
  onSearchChange: (search: string) => void;
  onToggleAll: () => void;
  search: string;
};

export function NoteFilters({
  dateEnd,
  dateStart,
  isAllSelected,
  isAuthorizedToExportNotes,
  onDateEndChange,
  onDateStartChange,
  onNoteTypeChange,
  onSearchChange,
  onToggleAll,
  search,
}: NoteFiltersProps) {
  return (
    <ul
      className={cn(
        "tw:grid-cols- tw:grid tw:gap-5",
        isAuthorizedToExportNotes
          ? "tw:xl:grid-cols-[min-content_1fr_1fr_1fr]"
          : "tw:xl:grid-cols-3",
      )}
      data-public
    >
      {isAuthorizedToExportNotes && (
        <li>
          <Checkbox2
            className="input-label-placeholder tw:flex tw:flex-col-reverse tw:items-start tw:xl:gap-5"
            isSelected={isAllSelected}
            onClick={onToggleAll}
          >
            Select
          </Checkbox2>
        </li>
      )}

      <li>
        <NoteTypeFilter onChange={(id) => onNoteTypeChange(id)} />
      </li>

      <li>
        <DateRangeFilter
          dateEnd={dateEnd}
          dateStart={dateStart}
          onDateEndChange={onDateEndChange}
          onDateStartChange={onDateStartChange}
        />
      </li>

      <li>
        <SearchFilter onChange={onSearchChange} value={search} />
      </li>
    </ul>
  );
}
